<div class="bit-pattern-editor-container flex-row">
  <span *ngIf="showHexValue">{{ bitPattern.toString() | hexValue }}</span>
  <div class="checkbox-list-container flex-row">
    <div class="checkbox-list-item" *ngFor="let item of checkboxList; let index = index">
      <mat-checkbox [disabled]="isDisabled(index)" [checked]="isChecked(index)" (change)="checkedChanged(index, $event.checked)">{{ item }}</mat-checkbox>
    </div>
  </div>
</div>
